import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { isAuthenticated } from "@/utils/auth";
import { useEffect } from "react";
import axios from "axios";

export default function Login() {
  const [email, setEmail] = useState("");
  const [parol, setParol] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();


  useEffect(() => {
  if (isAuthenticated()) {
    navigate("/");
  }
}, []);

 const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await axios.post(
      "https://api.imtahanplus.com/admin/login-admin",
      { email, parol }
    );

    const data = response.data;

    // token saxla
    localStorage.setItem("token", data.token);

    toast.success(data.message || "Uğurla daxil oldunuz!");

    navigate("/");
  } catch (error) {
    toast.error(
      error?.response?.data?.error || error.message || "Login xətası"
    );
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="flex items-center justify-center h-screen">
      <form
        onSubmit={handleLogin}
        className="w-[350px] p-6 shadow-lg rounded-xl bg-white"
      >
        <h2 className="text-2xl font-bold mb-4 text-center">Admin Login</h2>

        <input
          type="email"
          placeholder="Email"
          className="w-full border p-2 mb-3 rounded"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="parol"
          placeholder="parol"
          className="w-full border p-2 mb-3 rounded"
          value={parol}
          onChange={(e) => setParol(e.target.value)}
        />

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700"
        >
          {loading ? "Giriş edilir..." : "Login"}
        </button>
      </form>
    </div>
  );
}